var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-change-num comp"},[(!_vm.fn)?_c('nav-tips',{attrs:{"data":_vm.titTips}}):_vm._e(),_c('div',{staticClass:"con"},[_c('set-pwd',{attrs:{"pwd-con":_vm.pwdSet},on:{"pwd-get":_vm.pwdOk}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }